<div class="container-fluid">
    <app-pagetitle title="API & Integration" [subtitle]="'Integrate AVSS eSign and eStamp into your applications'"></app-pagetitle>

    <div class="page-content-wrapper">
        <div [class.loading-content]="loading">
            <app-loader [loading]="loading"></app-loader>

    <!-- Tab Navigation Header -->
    <div class="row mb-4">
        <div class="col-lg-12">
            <ul class="nav nav-tabs border-bottom" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link fw-bold" [class.active]="activeTab === 'esign'" (click)="switchTab('esign')"
                        type="button" role="tab" [attr.aria-selected]="activeTab === 'esign'">
                        <i class="bi bi-pen"></i> E-Sign Integration
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link fw-bold" [class.active]="activeTab === 'estamp'"
                        (click)="switchTab('estamp')" type="button" role="tab"
                        [attr.aria-selected]="activeTab === 'estamp'">
                        <i class="bi bi-stamp"></i> E-Stamp Integration
                    </button>
                </li>
            </ul>
        </div>
    </div>




    <ng-container *ngIf="activeTab == 'esign'; else estampData">

        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <p class="fw-bold fs-5 mb-0">API Keys</p>
                        <button class="btn btn-primary btn-sm" (click)="generateApiKey()">+ Generate New Key</button>
                    </div>

                    <div class="card-body">
                        @if(loading){
                        <div class="text-center fw-bold">Loading data...</div>
                        }
                        @if(!loading && apiKeys && apiKeys.length > 0){
                        <div class="table-responsive">
                        <table class="table align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>Key Name</th>
                                    <th>API Key</th>
                                    <th>Created</th>
                                    <th>Last Used</th>
                                    <th>Calls</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>

                            <tbody>
                                @for(api of apiKeys; track api;) {
                                <tr>
                                    <td class="fw-bold">{{ api.name }}</td>
                                    <td>
                                        <div class="d-flex align-items-center gap-2">
                                            <pre class="mb-0">{{ api.key }}</pre>
                                            <i class="mdi mdi-content-copy" (click)="copyToClipboard(api.key)" style="cursor: pointer; opacity: 0.6;" title="Copy API Key"></i>
                                        </div>
                                    </td>
                                    <td>{{ api.createdAt | date }}</td>
                                    <td>{{ api.updatedAt | date }}</td>
                                    <td>{{api.usageCount}}</td>
                                    <td>{{api.status}}</td>
                                    <td>
                                        <button class="btn btn-sm btn-outline-primary" (click)="revokeApiKey(api)"
                                            [disabled]="api.status.toLowerCase() == 'revoked'">
                                            Revoke
                                        </button>
                                    </td>
                                </tr>
                                }
                            </tbody>
                        </table>
                        </div>
                        }
                        @if(!loading && apiKeys.length == 0){
                        <div class="text-center fw-bold">No API Keys available.</div>
                        }
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <app-documentataion [activeTab]="activeTab"></app-documentataion>
            </div>
        </div>

        <div class="row g-4" *ngIf="false">
            <div class="col-lg-12 d-flex">
                <div class="card flex-fill">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <p class="fw-bold fs-5 mb-0">Webhooks</p>
                    </div>

                    <div class="card-body d-flex flex-column">
                        <div class="row mb-3">
                            <div class="col-12 text-start">

                                <input type="text" class="form-control" [(ngModel)]="webHookUrl"
                                    placeholder="https://example.com/webhook" />
                            </div>
                        </div>

                        <div class="mt-auto">
                            <button class="btn btn-primary w-25" (click)="saveWebHook()" [disabled]="!webHookUrl">
                                Save Webhook
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </ng-container>

    <ng-template #estampData>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <p class="fw-bold fs-5 mb-0">API Keys</p>
                        <button class="btn btn-primary btn-sm" (click)="generateApiKey()">+ Generate New Key</button>
                    </div>

                    <div class="card-body">
                        @if(loading){
                        <div class="text-center fw-bold">Loading data...</div>
                        }
                        @if(!loading && estampApiKeys && estampApiKeys.length > 0){
                        <div class="table-responsive">
                        <table class="table align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>Key Name</th>
                                    <th>API Key</th>
                                    <th>Created</th>
                                    <th>Last Used</th>
                                    <th>Calls</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>

                            <tbody>
                                @for(api of estampApiKeys; track api;) {
                                <tr>
                                    <td class="fw-bold">{{ api.name }}</td>
                                    <td>
                                        <div class="d-flex align-items-center gap-2">
                                            <pre class="mb-0">{{ api.key }}</pre>
                                            <i class="mdi mdi-content-copy" (click)="copyToClipboard(api.key)" style="cursor: pointer; opacity: 0.6;" title="Copy API Key"></i>
                                        </div>
                                    </td>
                                    <td>{{ api.createdAt | date }}</td>
                                    <td>{{ api.updatedAt | date }}</td>
                                    <td>{{api.usageCount}}</td>
                                    <td>{{api.status}}</td>
                                    <td>
                                        <button class="btn btn-sm btn-outline-primary" (click)="revokeApiKey(api)"
                                            [disabled]="api.status.toLowerCase() == 'revoked'">
                                            Revoke
                                        </button>
                                    </td>
                                </tr>
                                }
                            </tbody>
                        </table>
                        </div>
                        }
                        @if(!loading && estampApiKeys.length == 0){
                        <div class="text-center fw-bold">No API Keys available.</div>
                        }
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <app-documentataion [activeTab]="activeTab"></app-documentataion>
            </div>
        </div>
    </ng-template>

</div>

@if(showModal){
<div class="modal fade show d-block">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title">Create API</h5>
                <button class="btn-close" (click)="closeModal()"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div>
                            <label class="form-label" for="api-name">
                                API Key Name
                            </label>
                            <input type="text" class="form-control" id="api-name" placeholder="API Key Name"
                                [(ngModel)]="apiKeyName">
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button class="btn btn-primary w-100" type="submit" [disabled]="!apiKeyName"
                    (click)="createApiKey()"><span *ngIf="loading" class="spinner-border spinner-border-sm me-2"
                        role="status" aria-hidden="true"></span>
                    {{loading ? 'Loading...' : 'Submit'}}</button>
            </div>

        </div>
    </div>
</div>
}

@if(showModal){
<div class="modal-backdrop fade show"></div>
}